<script setup>
import { ref, onMounted } from "vue";
//import Conf from '@/Components/MainGlobal.vue';
import SeoMeta from '@/Components/SeoMeta.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';

import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { defineComponent } from 'vue';
import { GoogleMap, Marker } from "vue3-google-map";
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import '@splidejs/vue-splide/css';

import BaseIcon from "@/Components/BaseIcon.vue";
import {
    mdiMagnify,
    mdiChevronDown,
    mdiAccountOutline,
    mdiCartOutline,
    mdiHeartOutline,
    mdiMenu,
    mdiCloseThick,
    mdiHeadset,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiWhatsapp,
    mdiYoutube,
    mdiTruckFastOutline,
    mdiReload,
    mdiShieldLockOutline,
    mdiTrophyOutline,
    mdiArrowRight,
    mdiShoppingOutline,
    mdiStar,
    mdiClose,
    mdiBroom,
    mdiArrowExpandAll,
    mdiRepeat,
    mdiChevronRight,
    mdiMinus,
    mdiPlus,
    mdiFlagVariant,
    mdiMoped,
    mdiPercent,
    mdiPhone,
    mdiEmail,
    mdiMapMarker,
    mdiCart,
    mdiCheckCircle,
    mdiCloseCircle,
    mdiSend,
    mdiLoading

} from "@mdi/js";

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String,
    contentWelcome: String,
    accessStudents: Boolean,
    accessParents: Boolean,
    object: Object,
    tallas: Array,
    categoryChild: Object,
    categoryParent: Object,
    qty: Number,
    cot: {
        type: Number,
        default: 0
    },
    brands: Object
    //connstantes: Array

})



// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

const formInertia = useForm({
    email: '',
    nombre: '',
    phone: '',
    comment: '',
    recibirinfo: false
});
const isModalActive = ref(false);

const stocklabel = ref(false)



// Información de Slide, limite x 4

const slidePrincipal = ref(null)
slidePrincipal.value = [
    { 'id': '01', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-1.png' },
    { 'id': '02', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-2.png' },
    { 'id': '03', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-3.png' },
]

//produtos nuevos ORDER BY created_at LIMIT 8
const productosNuevos = ref(null)
productosNuevos.value = [
    { 'id': '28', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/01.jpg' },
    { 'id': '27', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 0, 'rating': 1, 'stock': '0', 'ruta_imagen': '/img/productos/02.jpg' },
    { 'id': '26', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 0, 'stock': '2', 'ruta_imagen': '/img/productos/03.jpg' },
    { 'id': '25', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/04.jpg' },
    { 'id': '24', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '1', 'ruta_imagen': '/img/productos/05.jpg' },
    { 'id': '23', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/06.jpg' },
    { 'id': '22', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/07.jpg' },
    { 'id': '21', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/08.jpg' }
]

const productosDestacados = ref(null)
productosDestacados.value = [
    { 'id': '31', 'label': 'Monitor Curvo Samsung 49″ WQLED LS49A950', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/20.jpg' },
    { 'id': '32', 'label': 'Tablet Samsung Galaxy Tab S7 Fe 64gb', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/21.jpg' },
    { 'id': '33', 'label': 'Asus ROG Strix RX5700 XT O8G 8GB', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/22.jpg' },
    { 'id': '34', 'label': 'Impresora HP LaserJet 107W', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/23.jpg' },
    { 'id': '35', 'label': 'Impresora Multifuncional Epson EcoTank L3110', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/24.jpg' },
    { 'id': '36', 'label': 'Mochila Lenovo Thinkpad Professional G2', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/25.jpg' }
]

const marcasRelacionadas = ref(null)
marcasRelacionadas.value = [
    { 'id': '101', 'ruta_imagen': '/img/marcas/01.png' },
    { 'id': '102', 'ruta_imagen': '/img/marcas/02.png' },
    { 'id': '103', 'ruta_imagen': '/img/marcas/03.png' },
    { 'id': '104', 'ruta_imagen': '/img/marcas/04.png' },
    { 'id': '105', 'ruta_imagen': '/img/marcas/05.png' },
    { 'id': '106', 'ruta_imagen': '/img/marcas/06.png' },
    { 'id': '107', 'ruta_imagen': '/img/marcas/07.png' },
    { 'id': '108', 'ruta_imagen': '/img/marcas/08.png' },
    { 'id': '109', 'ruta_imagen': '/img/marcas/09.png' },
    { 'id': '110', 'ruta_imagen': '/img/marcas/10.png' },
    { 'id': '111', 'ruta_imagen': '/img/marcas/11.png' },
    { 'id': '112', 'ruta_imagen': '/img/marcas/12.png' }
]

// Google maps
const YOUR_GOOGLE_MAPS_API_KEY = ref('AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg')
const center = ref({ lat: -11.992628, lng: -77.071254 })
const locations = ref([
    { lat: -11.992628, lng: -77.071254 }
])

onMounted(() => {
    getCart()
    validNumber()
});

// Valid
const nValid1 = ref(0)
const nValid2 = ref(0)
const resultHuman = ref('')
const resultvalid = ref(0)
const validNumber = () => {
    nValid1.value = Math.ceil(Math.random() * 10)
    nValid2.value = Math.ceil(Math.random() * 10)
    resultvalid.value = parseInt(nValid1.value) + parseInt(nValid2.value)
}

const carrito = ref([])
const getCart = () => {
    let cart = []
    //let cartStorage = localStorage.getItem('cart')
    let cartStorage = sessionStorage.getItem('cart')
    if (cartStorage && cartStorage.length > 0) {
        cart = JSON.parse(cartStorage)
        carrito.value = cart
    }
}

const form = ref({
    type: (props.cot ? 1 : 0), // 0 order y 1 cotizacion
    document: '',
    name: '',
    email: '',
    phone_mobile: '',
    delivery_address: '',
    note: '',
    products: '',
    id: (props.object ? props.object.id : 0),
    qty: (props.qty ? props.qty : 0)
})

const messagesuccess = ref('')
const messagedanger = ref('')
const submitting = ref(false)
const createOrder = async () => {
    //let ruta = 'eco-orderregistrar' // route(ruta)
    let url = '/ecommerce/orderregistrar';
    let arrprods = []
    submitting.value = true

    //form.value.products += '';
    if (props.object) {
        //form.value.products += '1.- Cod.: ' + props.object.ref + ' Nombre: ' + props.object.label + ' Cant.: ' + props.qty + ' Precio: ' + props.object.price_ttc;
        let obj = { 'id': props.object.id, 'ref': props.object.ref, 'label': props.object.label, 'cant': props.qty, 'price': props.object.price_ttc }
        arrprods.push(obj)
    } else {
        let cart = []
        let cartStorage = sessionStorage.getItem('cart')
        if (cartStorage && cartStorage.length > 0) {
            cart = JSON.parse(cartStorage)
            arrprods = cart
            console.log(cart)
        }
    }
    //form.value.products += '';
    form.value.products = arrprods

    await axios.post(url, form.value).then((response) => {
        let resp = response.data
        if (resp.success) {
            messagesuccess.value = resp.message
        } else {
            messagedanger.value = resp.message
        }
        //showAlert('Registro Creado', 'success')
        //listarPostit()
        console.log('Order Creada');
        console.log(response);
    }).catch((error) => {
        //showAlert('Registro actualizado', 'danger', 5)
        console.log(error.response)
        if (error.response.data) {
            let msg = error.response.data.message
            let poscut = msg.indexOf("(and") // cortar (and 2 more errors)
            let msgerror = msg.substr(0, poscut)
            if (poscut) {
                messagedanger.value = msgerror
            } else {
                messagedanger.value = msg
            }
        }   
        
    });
    submitting.value = false
}

// Remover carrito luego de solicitar no es necesario pues cuando cierra la página el carrito se vaciará 
// El carrito sólo se mantiene por session
/* const removeCart = () => {
    //let valid = confirm('Seguro de vaciar el carrito?')
    //if (valid) {
        sessionStorage.removeItem('cart')
        qtyCart.value = 0
        console.log('Del All Cart')
        window.location.href = '/'
        //getCart()
        //let button = document.getElementById('button-seguir-comprando');
        //button.click();
    //}

} */

</script>

<template>
    <SeoMeta />
    <!-- Head con categorías -->
    <BreezeGuestLayout :categoryChild="categoryChild" :categoryParent="categoryParent">

        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->

        <section>
            <div class="w-full h-[250px ] relative">
                <div aria-hidden="true" class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 inset-0 absolute bg-[url('/img/order/header.jpg')] bg-no-repeat bg-center bg-cover">
                </div>
                <div class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 absolute inset-0 bg-black bg-opacity-50">
                </div>
                <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-20">
                    <div class="relative flex flex-col lg:flex-row lg:justify-between items-center">
                        <div>
                            <h1 class="text-2xl lg:text-3xl text-white">Su Información y Dirección</h1>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-white font-semibold">Inicio / <span class="text-xs lg:text-sm font-normal">Pedido</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->

        <!-- START AREA DE CONTACTO -->
        <!-- START AREA DE CONTACTO -->
        <!-- START AREA DE CONTACTO -->

        <section>
            <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:pt-16">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-16">
                    <div class="col-span-1">
                        <div class="mb-6">
                            <h1 class="text-2xl lg:text-3xl font-bold mb-2">Detalle sus datos</h1>
                            <p class="text-sm">Rellena el siguiente formulario para continuar con la compra.</p>
                        </div>
                        <BreezeValidationErrors class="mb-4 mt-4" />
                        <form>
                            <div class="grid grid-cols-12 gap-5 input-group">

                                <div class="col-span-12">
                                    <input type="hidden" v-model="form.type">
                                    <input type="text" v-model="form.document" class="w-full" placeholder="Escriba su Documento/RUC" required name="document">
                                </div>
                                <div class="col-span-12">
                                    <input type="text" v-model="form.name" class="w-full" placeholder="Escriba su Nombre/Razón Social" required name="name">
                                </div>
                                <div class="col-span-12 lg:col-span-8">
                                    <input type="email" v-model="form.email" class="w-full" placeholder="Correo electrónico" required name="email">
                                </div>
                                <div class="col-span-12 lg:col-span-4">
                                    <input type="text" v-model="form.phone_mobile" class="w-full [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" placeholder="Teléfono/Celular" required name="phone">
                                </div>
                                <div class="col-span-12">
                                    <input type="text" v-model="form.delivery_address" class="w-full" placeholder="Dirección de envio" required name="address">
                                </div>
                                <div class="col-span-12">
                                    <textarea v-model="form.note" placeholder="Escribanos su mensaje aqui (opcional)." class="w-full" rows="5"></textarea>
                                </div>

                                <!-- Valid -->
                                <div class="col-span-12 ">
                                    <div v-if="!messagesuccess" class="inline-flex p-4 rounded-md items-center space-x-3 border-2 transition-all duration-300 ease-in-out bg-cover bg-center" :class="(resultHuman == resultvalid ? 'bg-green-50 border-green-600 bg-[url(/img/captcha-2.svg)]' : 'border-gray-400  hover:!border-gray-600 bg-white bg-[url(/img/captcha-1.svg)]')">
                                        <div class="text-xs mr-2 lg:mr-4 font-extrabold"><span style="text-shadow: -2px 0 #ffffff, 0 2px #ffffff, 2px 0 #ffffff, 0 -2px #ffffff">Por su seguridad<br>resuelva esta operación.</span></div>
                                        <div class="flex flex-wrap items-center text-2xl lg:text-3xl">
                                        <div class="!font-['Rubik_Dirt']">{{ nValid1 }} + {{ nValid2 }} =</div>
                                            <input type="text" v-model="resultHuman" class="w-12 ml-2 !focus:ring-0 text-center" required>
                                        </div>
                                    </div>
                                </div>

                                <!-- Alert -->
                                <div v-if="messagesuccess" class="col-span-12 bg-green-50 border-green-600 text-sm px-3 py-2 border justify-left rounded-md flex items-center space-x-3">
                                    <BaseIcon :path="mdiCheckCircle" :size="24" w="w-4" h="h-4" class="text-green-600"></BaseIcon> <span class=" text-green-600">{{ messagesuccess }}</span>
                                </div>
                                <div v-if="messagedanger && !messagesuccess" class="col-span-12 bg-red-50 border-red-600 text-sm px-3 py-2 border justify-left rounded-md flex items-center space-x-3">
                                    <BaseIcon :path="mdiCloseCircle" :size="24" w="w-4" h="h-4" class="text-red-600"></BaseIcon><span class=" text-red-600">{{ messagedanger }}</span>
                                </div>

                                <!-- Buttons -->
                                <div class="col-span-12">
                                    <button v-if="!messagesuccess " type="button" class="btn btn-color px-8 space-x-3 flex items-center"  @click="createOrder()" :disabled="(submitting || resultHuman != resultvalid)" :class="(resultHuman != resultvalid ? 'cursor-none opacity-50 hover:!bg-sky-500 focus-!ring-0' : '')">

                                        <BaseIcon :path="(submitting ? mdiLoading : mdiSend)" :size="24" w="w-4" h="h-4" class="text-white" :class="(submitting ?'animate-spin': '')"></BaseIcon>
                                        
                                        <span>{{ (cot ? 'Solicitar Cotización' : 'Solicitar Pedido') }}</span>
                                    </button>

                                    <Link v-if="messagesuccess && !cot" :href="route('eco-checkout')">
                                        <BaseButton :icon="mdiCart" small label="Proceder con el pago" class="btn btn-color px-8" />
                                    </Link>
                                </div>

                            </div>
                        </form>
                    </div>
                    <div class="col-span-1">
                        <h1 class="sm:text-2xl text-xl font-semibold mb-5">{{ cot ? 'Resumen de la cotización' : 'Resumen del Pedido' }}</h1>
                        <div class="w-full p-5 lg:p-8 border border-gray-200 rounded-lg">
                            <div class="sub-total mb-6">
                                <div class=" flex justify-star mb-5">
                                    <p class="text-sm font-semibold uppercase">Productos</p>

                                </div>
                            </div>
                            <hr class="my-4">
                            <div class="w-full mb-4">
                                <ol class="flex flex-col space-y-5 list-none lg:list-disc ml-0">
                                    <li v-if="object">
                                        <div class="flex justify-between items-center">
                                            <div>
                                                <h4 class="text-xs lg:text-sm"><span class="font-semibold">{{ object.ref }}</span> x {{ qty }}</h4>
                                                <p class="text-sm lg:text-base">{{ object.label }}</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-for="(item, index) in carrito" :key="index">
                                        <div class="flex justify-between items-center">
                                            <div>
                                                <h4 class="text-xs lg:text-sm"><span class="font-semibold">SKU: {{ item.ref }}</span> x {{ item.cant }}</h4>
                                                <p class="text-sm lg:text-base">{{ item.label }}</p>
                                            </div>

                                        </div>
                                    </li>

                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- END AREA DE CONTACTO -->
        <!-- END AREA DE CONTACTO -->
        <!-- END AREA DE CONTACTO -->


        <!--START MARCAS -->
        <!--START MARCAS -->
        <!--START MARCAS -->
        <section class="py-8">
            <div class=" mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Marcas que Ofrecemos</h1>
                    </div>
                    <div>
                        <Link :href="route('eco-brands')">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </Link>
                    </div>
                </div>
                <div class="relative slider-marcas" v-if="brands.length > 0">
                    <hr class="my-4">
                    <Splide :has-track="true" :options="{ rewind: 'true', perPage: 6, perMove: 1, type: 'loop', autoplay: true, pagination: false, arrows: true, gap: '1em', breakpoints: { 1023: { perPage: 3 }, 640: { perPage: 2, } } }" class="rounded-md" id="">
                        <SplideSlide class="rounded-md h-full " v-for="(item, index) in brands" :key="item.id">
                            <div class="rounded-md h-full">
                                <div class="w-full h-[110px] lg:h-[130px] bg-white border-gray-100 border-color-light hover:border-2 flex justify-center items-center py-4 px-8">
                                    <Link :href="route('eco-product-category', { id: 0, label: '', originbrand: item.id })" class="">
                                        <img :src="(item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '')" class="hover:grayscale h-14 xl:h-20 object-contain">
                                    </Link>
                                </div>
                            </div>
                        </SplideSlide>
                    </Splide>
                    <hr class="my-4">
                </div>
            </div>
        </section>
        <!-- END MARCAS -->
        <!-- END MARCAS -->
        <!-- END MARCAS -->


        <!-- <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div class="grid grid-cols-2">
                <div class="col-span-1">
                    <Splide id="main-carousel" :options="{
                        type: 'fade',
                        rewind: true,
                        pagination: false,
                        arrows: false,
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>

                    <Splide :options="{
                        fixedWidth: 100,
                        fixedHeight: 60,
                        gap: 10,
                        rewind: true,
                        pagination: false,
                        cover: true,
                        focus: 'center',
                        breakpoints: {
                            600: {
                                fixedWidth: 60,
                                fixedHeight: 44,
                            },
                        },
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/04.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/05.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>
                </div>
            </div>

        </div> -->


    </BreezeGuestLayout>
</template>

<style scoped>
.splide__slide img {

    object-fit: cover;
}</style>
